import { Component, OnInit } from '@angular/core';
import { InvoiceDetailsComponent } from '../../invoice-details/invoice-details.component';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { invoiceStatusConstant } from '../../app.constant';
import { InvoicesService } from '../../services/invoices.service';
import { InvoicesParams } from '../../app.model';
import { BaseInvoicesComponent } from 'src/app/shared/base/base-invoices.component';


@Component({
  selector: 'app-bill-invoices',
  templateUrl: './bill-invoices.component.html',
  styleUrls: ['./bill-invoices.component.css']
})
export class BillInvoicesComponent extends BaseInvoicesComponent implements OnInit {

  public invoices: any = [];
  totalCount: number = 0;
  currentPage: number = 1;
  pageLimit: number = 20;
  public INVOICE_STATUS = invoiceStatusConstant;
  invoiceType = 'client';
  constructor(
    invoicesService: InvoicesService,
    activeModalService: NgbActiveModal,
    modalService: NgbModal,
  ) {
    super(invoicesService, activeModalService, modalService)
  }

  ngOnInit(): void {
    this.refreshInvoices(1);
  }

  refreshInvoices(page = 1) {
    const params: InvoicesParams = {
      limit: 20,
      page,
      start_date: '',
      end_date: '',
      status: '',
      order_by: '',
      order: '',
    };
    this.invoices = [];
    this.loading = true;
    this.invoicesService.getInvoices(page, params).subscribe((invoices: any) => {
      this.loading = false;
      this.invoices = invoices.data;
      this.totalCount = invoices.meta.total;
    });
  }

  onStepChange(event: any) {
    this.currentPage = event;
    this.refreshInvoices(event)
  }

  get pageStart(): number {
    return this.totalCount === 0 ? 0 : (this.currentPage - 1) * this.pageLimit + 1;
  }

  get pageEnd(): number {
    return Math.min(this.currentPage * this.pageLimit, this.totalCount);
  }

  viewInvoiceDetails(invoice: any, invoiceType: string) {
    this.modalRef = this.modalService.open(InvoiceDetailsComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: "static",
      modalDialogClass: 'update-client-modal',
    });
    this.modalRef.componentInstance.invoice = invoice;
    this.modalRef.componentInstance.invoiceType = invoiceType;
  }

  downLoadInvoice(invoice: any, invoiceType: any) {
    this.error = '';
    this.loading = true;

    this.invoicesService.downloadInvoice(invoice.uuid, invoiceType).subscribe((response: any) => {
      const fileUrl = response.report_path;

      // Create invisible <a> to trigger download
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = `invoice-${invoice.uuid}.pdf`; // suggest filename
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.loading = false;
    }, error => {
      this.loading = false;
      this.error = error;
    });

  }
}
